import { render, staticRenderFns } from "./DishRestaurantSettings.vue?vue&type=template&id=3ba0a9e7&"
import script from "./DishRestaurantSettings.vue?vue&type=script&lang=js&"
export * from "./DishRestaurantSettings.vue?vue&type=script&lang=js&"
import style0 from "./DishRestaurantSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports